import React from 'react'
import { IconButton } from '@mui/material'
import { ArrowForward } from '@mui/icons-material'
import { COLOR } from '../../../utils/constants/color.constants'

const UIIconButtonGoTo = ({ sx, ...props }) => {
  return (
    <IconButton
      sx={{
        borderRadius: '6px',
        '&:hover': {
          '& svg': {
            fill: COLOR.ORANGE,
          },
        },
        ...sx,
      }}
      {...props}
    >
      <ArrowForward sx={{ fill: COLOR.GRAY_MEDIUM }} />
    </IconButton>
  )
}

export default UIIconButtonGoTo
